import { Table, Space, Button } from "antd";
import React, { useContext } from "react";
import { PageContext } from "../../../../lib/context";
import UsersForm from './form';
import CreateDrawer from '../../../../components/create';
import Loading from "../../../../components/loader";

const UsersView = () => {
  const { data, usersData, usersColumns, _submitHandler, loading } = useContext(PageContext);

  return (
    <div className="flex flex-col px-10">
      <div className="items-start align-start">
        <p className="text-3xl font-bold">Users</p>
      </div>
      <p className="text-xl font-bold mt-5">Manage System Users</p>
      <div className="flex flex-row">
        <div className="w-4/5 mr-3">
          <div className="py-5">
            <Space>
              <CreateDrawer
                title="Create User"
                _submitHandler={_submitHandler}
                width={500}
              >
                <UsersForm />
              </CreateDrawer>
            </Space>
          </div>
          {loading ? (
            <div className="mt-32">
              <Loading show={loading} />
            </div>
          ) : (
            <Table dataSource={usersData} columns={usersColumns} />)
          }
        </div>
      </div>
    </div>
  );
}

export default UsersView;